import React from 'react'
import NotificationModal from 'views/modals/notification_modal.jsx'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import paywallReminderSelector from 'redux/selectors/my_library/my_library_paywall_reminder_selector'
import myLibraryActions from 'redux/actions/my_library_actions'
import { localize, localizeWithVars } from 'helpers/translator/localize'

import paywallIcon from 'assets/confirms/paywall-icon.svg'

const MyLibraryPaywallReminderConfirm = props => (
	<NotificationModal
		alertTitle={localizeWithVars('login_notification_extended_features_reminder_days_title', { daysLeft: props.daysLeft })}
		btnOne={localize('action_button_upgrade_now')}
		alertMessage={localize('login_notification_extended_features_reminder_days')}
		buttonDismissText={localize('action_button_remindlater')}
		actionOne={props.actions.upgradeReminderPaywall}
		closeAction={props.actions.closeReminderPaywall}
		buttonDismissAction={props.actions.closeReminderPaywall}
		imgIcon={paywallIcon}

	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		upgradeReminderPaywall: myLibraryActions.upgradeReminderPaywall,
		closeReminderPaywall: myLibraryActions.closeReminderPaywall,
	}, dispatch)
}

function mapStateToProps(state) {
	return paywallReminderSelector(state)
}

export default connect(mapStateToProps, mapDispatchToProps)(MyLibraryPaywallReminderConfirm)

export { MyLibraryPaywallReminderConfirm }
